<template>
  <div style="margin-top: 24px">
    <v-simple-table height="600" fixed-header class="table-layout">
      <template v-slot:default>
        <thead>
          <tr>
            <th style="min-width: 150px; max-width: 150px">User</th>
            <th>Thời gian</th>
            <th>Mô tả</th>
          </tr>
        </thead>
        <tbody v-if="items && items.length > 0">
          <tr v-for="(item, index) in items" :key="'note' + index">
            <td>{{item.creator.firstName}} {{item.creator.lastName}}</td>
            <td>{{formatDateCus(item.update_date, 'YYYY-MM-DD HH:mm:ss')}}</td>
            <td>{{item.note}}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3">
              <div style="color: red" class="d-flex align-center justify-center">Không có dữ liệu</div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import ContactRepository from '@/services/ContactRepository';

export default {
  name: 'NoteTab',
  props: {
    id: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  created() {
    this.getListNotes();
  },
  methods: {
    async getListNotes() {
      const res = await ContactRepository.getListNote(this.id);
      if (res && res.message === 'Success') {
        this.items = res.data;
      }
    },
  },
};
</script>

<style scoped>
.table-layout .v-data-table__wrapper thead th {
  background: #F7F7FC;
  font-size: 14px;
}
</style>
